<template>
  <div class="privacy-policy">
      <h1>Privacy Policy</h1>
      <p><strong>Effective Date:</strong> Jan 1, 2025</p>
      
      <p>
        <b>Dungeon Quest Idle</b> values your privacy. This Privacy Policy explains
        how we handle your information while you use our game and services.
      </p>
      
      <hr />
  
      <h2>Information We Collect</h2>
      <p>
        We do not collect or store any personal information from our users. All 
        gameplay data and settings are stored locally on your device. This 
        information is not transmitted to any server or third party.
      </p>
  
      <h2>In-App Purchases and Restore</h2>
      <p>
        For in-app purchases and restore functionality, we rely on third-party 
        services such as Google Play. These platforms handle transactions securely 
        and may collect information as described in their respective privacy 
        policies. We do not have access to or store any personal or financial 
        information related to these transactions.
      </p>
  
      <hr />
  
      <h2>Third-Party Services</h2>
      <p>We use the following third-party services:</p>
      <ul>
        <li>
          <strong>Google Play Store:</strong> To enable in-app purchases and 
          restore functionalities.
        </li>
      </ul>
      <p>
        Please refer to their respective privacy policies for more information on 
        how they handle your data.
      </p>
  
      <hr />
  
      <h2>Children’s Privacy</h2>
      <p>
        Our game is not intended for children under 13. We do not knowingly collect 
        any personal information from children under 13. If you believe we have 
        inadvertently collected such information, please contact us immediately.
      </p>
  
      <hr />
  
      <h2>Changes to This Privacy Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Changes will be 
        effective upon posting, and we will notify users of significant updates.
      </p>
  
      <hr />
  
      <h2>Contact Us</h2>
      <p>
        If you have any questions or concerns about this Privacy Policy, please 
        contact us:
      </p>
      <ul>
        <li><strong>Email:</strong> <a href="mailto:chayanutp39@gmail.com">chayanutp39@gmail.com</a></li>
      </ul>
    </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy',
  props: {
    // msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.privacy-policy {
    max-width: 800px;
    margin: 0 auto;
    padding: 2rem;
    line-height: 1.6;
    
    color: white;
    background-color: #252525; /* Or a light background color */
    /* border: 1px solid #ffffff;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); */
    font-family: sans-serif;
  }
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
